import React, { ChangeEventHandler, useEffect, useRef } from "react";
import clsx from "clsx";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  sizing?: "sm" | "md";
  id?: string;
  indeterminate?: boolean;
  checked?: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

const Checkbox = ({ id, checked = false, onChange, sizing = "sm", indeterminate = false, ...props }: Props) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      id={id}
      ref={ref}
      checked={checked}
      onChange={onChange}
      type="checkbox"
      {...props}
      className={clsx(
        "hover:border-fg-quinary-hover hover:shadow-sm focus:ring-0 focus-visible:ring-4 focus-visible:ring-focus-input active:border-fg-quinary-pressed",
        "checked:border-transparent checked:bg-brand-primary-solid checked:hover:bg-brand-primary-solid-hover checked:focus-visible:ring-focus-input checked:active:bg-brand-primary-solid-pressed",
        "indeterminate:border-transparent indeterminate:bg-brand-primary-solid indeterminate:hover:bg-brand-primary-solid-hover indeterminate:focus-visible:ring-focus-input indeterminate:active:bg-brand-primary-solid-pressed",
        "border border-fg-quinary bg-white shadow-xs !ring-offset-0",
        "form-checkbox cursor-pointer appearance-none rounded transition duration-75 ease-in-out disabled:cursor-not-allowed disabled:opacity-40",
        sizing === "sm" ? "h-4 w-4" : "h-5 w-5",
        props.className,
      )}
    />
  );
};

export default Checkbox;
